// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3a30e08a","239":"2b5127d8","455":"f5e84845","952":"bbe35cf7"}[chunkId] + ".chunk.js";
};